export default {
  path: "/monitoramento",
  name: "monitoramento",
  component: () => import("../pages/index.vue")
};
